import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

let tokenGetter = null;
export const setTokenGetter = (fn) => {
  tokenGetter = fn;
};

export const api = axios.create({ baseURL: API });
api.interceptors.request.use(async (config) => {
  if (tokenGetter) {
    const t = await tokenGetter();
    if (t) config.headers.Authorization = `Bearer ${t}`;
  }
  return config;
});

export const fmtDT = (v) => (v ? new Date(v).toLocaleString([], { dateStyle: "medium", timeStyle: "short" }) : "—");
export const fmtDur = (s) => {
  const n = Math.max(0, Math.floor(s || 0));
  return `${Math.floor(n / 60)}:${String(n % 60).padStart(2, "0")}`;
};

export const errMsg = (e) => {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (d?.reason) return d.reason + (d.next_eligible_at ? ` — next eligible ${fmtDT(d.next_eligible_at)}` : "");
  if (Array.isArray(d)) return d.map((x) => x.msg).join(", ");
  return e?.message || "Something went wrong";
};

export const label = (s) => (s ? String(s).replace(/_/g, " ").replace(/^\w/, (c) => c.toUpperCase()) : "—");
